import { TableRow } from "@mui/material";
import { styled } from "@mui/system";

export const TableRowRoot = styled(TableRow)({
  "& > *": {
    borderBottom: "unset"
  }
});
